import React, { useState} from 'react'
import { useStore } from '../../Store'

import { Box, FormControlLabel, TextField, MenuItem, Checkbox, Grid, Button } from '@material-ui/core';

const FeatureFilter = ({ filter:defaults, onSubmit, onCancel }) => {
    defaults.taxId = defaults.taxId || -1;
    defaults.sex = defaults.sex || "-1";
    defaults.lifestage= defaults.lifestage || -1;

    const [filter, setFilter]= useState(defaults)

    const { years, settings } = useStore()

    const seasons = years.map(item => { return (<MenuItem key={item.id} value={item.id}>{item.description}</MenuItem>) })

    const taxId = [{ id: -1, name: 'alle' }, ...settings.lists['taxon']]
        .map(item => { return (<MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>) })

    const sex = [{ id: -1, value:'-1', name: 'alle' }, ...settings.lists['sex']]
        .map(item => { return (<MenuItem key={item.id} value={item.value}>{item.name}</MenuItem>) })

    const lifestage = [{ id: -1, name: 'alle' }, ...settings.lists['lifestage']]
        .map(item => { return (<MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>) })

    const changeStartSeason = (e) => {
        const start= e.target.value
        const stop= (filter.stopSeasonId > start ? filter.stopSeasonId : start)
        setFilter({ ...filter, startSeasonId: start, stopSeasonId: stop })
    }
    const changeStopSeason = (e) => {
        const stop= e.target.value
        const start= (filter.startSeasonId < stop ? filter.startSeasonId : stop)
        setFilter({ ...filter, startSeasonId: start, stopSeasonId: stop })
    }

    const submit = () => {
        if (filter.startSeasonId !== filter.stopSeasonId
            && filter.taxId === -1
            && filter.isObserver === false) {
                alert('Kies één seizoen of één soort of alleen eigen waarnemingen')
            }
        else {
            onSubmit(filter)
        }

    }
        
    return (
        <Box m={2}>
        <Grid container>
            <Grid item xs={12}>
                <TextField select label="vanaf" variant="standard" name="startSeasonId" fullWidth value={filter.startSeasonId} onChange={changeStartSeason}>
                    {seasons}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField select label="t/m" variant="standard" name="stopSeasonId" fullWidth value={filter.stopSeasonId} onChange={changeStopSeason}>
                    {seasons}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField select label="soort" variant="standard" name="taxId" fullWidth value={filter.taxId} onChange={(e) => setFilter({...filter, taxId:e.target.value})}>
                    {taxId}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField select label="geslacht" variant="standard" name="sex" fullWidth value={filter.sex} onChange={(e) => setFilter({...filter, sex:e.target.value})}>
                    {sex}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField select label="stadium" variant="standard" name="lifestage" fullWidth value={filter.lifestage} onChange={(e) => setFilter({...filter, lifestage:e.target.value})}>
                    {lifestage}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel 
                    control={<Checkbox checked={filter.isObserver} onChange={(e) => setFilter({...filter, isObserver:e.target.checked})} />}
                    label="alleen eigen waarnemingen"
                />
            </Grid>
            <Grid item xs={6}>
                <Button variant="contained" color="primary" onClick={submit}>Filter</Button>
            </Grid>
            <Grid item xs={6}>
                <Button variant="contained" color="secondary" onClick={onCancel}>Sluiten</Button>
            </Grid>
        </Grid>
        </Box>
    )
}


export default FeatureFilter
